<template>
  <v-layout align-center justify-end row>
    <v-btn
      outline
      v-if="verificarSegundaVia()"
      :color="highContrast ? 'white' : 'primary'"
      @click="criarRascunho()"
      >SOLICITAR 2º VIA</v-btn
    >
    <etapas-rascunho
      :codigo-beneficiario="this.dadosBeneficiario.id"
      :exibir-rascunho-dialog="exibirRascunhoDialog"
      :usuario-id="this.usuario.id"
      @ocultar-rascunho-dialog="ocultarRascunhoDialog()"
    ></etapas-rascunho>
    <modal-movimento-aberto
      @close="modal.MOVIMENTO_ABERTO.visible = false"
      :show="modal.MOVIMENTO_ABERTO.visible"
      :message="modal.MOVIMENTO_ABERTO.content"
    ></modal-movimento-aberto>
    <modal-movimento-duplicado
      @close="modal.MOVIMENTO_DUPLICADO.visible = false"
      @overwrite="sobrescreverMovimento"
      :show="modal.MOVIMENTO_DUPLICADO.visible"
      :message="modal.MOVIMENTO_DUPLICADO.content"
    ></modal-movimento-duplicado>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import { PARAMETROS, WEB_SERVICE } from "@/constants";

import ModalMovimentoAberto from "@/components/ModalMovimentoAberto";
import ModalMovimentoDuplicado from "@/components/ModalMovimentoDuplicado";

import { buscaParametroValorTipoBooleanAtivo } from "@/services/beneficiario";
import {
  getMovimentosDuplicados,
  cancelarMovimentos
} from "@/services/movimentos";

import EtapasRascunho from "./etapas-rascunho";

const { mapState } = createNamespacedHelpers("portal");

export default {
  name: "SegundaVia",
  props: {
    dadosBeneficiario: Object,
    familiaPessoa: Array
  },
  components: { EtapasRascunho, ModalMovimentoAberto, ModalMovimentoDuplicado },
  computed: {
    ...mapState(["highContrast", "usuario"])
  },
  data() {
    return {
      bloquearRascunho: false,
      exibeBotaoSegundaVia: false,
      exibirRascunhoDialog: false,
      modal: {
        MOVIMENTO_ABERTO: { visible: false, content: null },
        MOVIMENTO_DUPLICADO: {
          visible: false,
          content: null,
          movimentoId: null
        }
      }
    };
  },
  async created() {
    this.exibeBotaoSegundaVia = await buscaParametroValorTipoBooleanAtivo(
      PARAMETROS.HABILITAR_SOLICITACAO_SEGUNDA_VIA
    );
  },
  methods: {
    async criarRascunho() {
      await this.verificarMovimentoDuplicado();

      if (!this.bloquearRascunho) {
        this.exibirRascunhoDialog = true;
      }
    },
    sobrescreverMovimento() {
      const movimentosId = this.modal.MOVIMENTO_DUPLICADO.movimentosId;

      cancelarMovimentos(movimentosId).finally(() => {
        this.modal.MOVIMENTO_DUPLICADO.visible = false;
        this.bloquearRascunho = false;

        this.criarRascunho();
      });
    },
    ocultarRascunhoDialog() {
      this.exibirRascunhoDialog = false;
    },
    usuarioTitularFamilia() {
      return this.familiaPessoa
        .filter(
          beneficiario =>
            beneficiario.contratoId === this.dadosBeneficiario.contratoId &&
            beneficiario.pessoaId === this.usuario.pessoaId
        )
        .map(beneficiario => beneficiario.titular)[0];
    },
    async verificarMovimentoDuplicado() {
      await getMovimentosDuplicados({
        codigoBeneficiario: this.dadosBeneficiario.id,
        tipoMovimentoId: 3
      }).then(response => {
        const errorMessage = response.data?.message;

        if (errorMessage) {
          this.bloquearRascunho = true;

          const resultado = errorMessage.split("|");

          if (WEB_SERVICE.includes(resultado[0])) {
            this.setErrorToast(errorMessage);
          } else {
            this.modal.MOVIMENTO_ABERTO.visible = true;
            this.modal.MOVIMENTO_ABERTO.content = errorMessage.replace(
              "\n",
              "<br>"
            );
          }
        } else {
          if (response.length) {
            const movimento = response.filter(
              movimento =>
                movimento?.nomeBeneficiario &&
                movimento?.tipoMovimento?.descricao
            )[0];
            const movimentosId = response.map(movimento => movimento.id);

            this.bloquearRascunho = true;
            this.loading = false;
            this.modal.MOVIMENTO_DUPLICADO.visible = true;
            this.modal.MOVIMENTO_DUPLICADO.content = `Foi encontrado um movimento de ${
              movimento?.tipoMovimento?.descricao
            } criado para ${movimento?.nomeBeneficiario}!`;
            this.modal.MOVIMENTO_DUPLICADO.movimentosId = movimentosId;
          }
        }
      });
    },
    verificarSegundaVia() {
      return (
        this.exibeBotaoSegundaVia &&
        (this.usuarioTitularFamilia() &&
          this.dadosBeneficiario.ativo &&
          !this.dadosBeneficiario.dataExclusao &&
          this.dadosBeneficiario.planoIndividualFamiliar)
      );
    }
  }
};
</script>
